module.exports = __webpack_public_path__ + "img/78.c0244fb9.jpg";